import React from 'react'
import KnockoutButton from '../../../General/KnockoutButton'
import { observer } from 'mobx-react-lite'

const Links = observer(({ links }) => {
	if (!links) return null

	const handleOnClick = (href) => {
		window.open(href, '_blank')
	}

	return (
		<div className="links">
			{links.map((l, i) => (
				<KnockoutButton
					style={{ marginRight: '1.25rem' }}
					key={l.label + i}
					label={l.label}
					onClick={() => handleOnClick(l.link)}
				/>
			))}

			<style jsx>{`
				.links {
					padding-right: 2.5rem;
					min-width: 0;
				}
			`}</style>
		</div>
	)
})

export default Links
